import {
    BlockStack,
    Button,
    ChoiceList,
    Collapsible,
    Icon,
    InlineStack,
    Select,
    Text,
    TextField,
} from '@shopify/polaris';
import { ChevronDownMinor } from '@shopify/polaris-icons';
import { Drawer } from 'antd';
import { keys } from 'lodash';
import React, { useEffect, useState } from 'react';
import { DatePicker } from "antd";
import moment from 'moment';
const { RangePicker } = DatePicker;
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const FilterBy = (props: any) => {
    const { t } = useTranslation();
    const { value, setValue } = props;
    const [open, setOpen] = useState(-1);
    let date = new Date();
    var nowDate = moment(date);
    const dateFormatList = ["DD/MM/YYYY"];

    const { active, setActive, } = props;
    const filterData = [
        {
            label: t('Process'),
            subFilters: [
                {
                    label: t('Sync status'),
                    value: 'sync_status',
                },
                {
                    label: t('Product Import'),
                    value: 'product_import',
                },
                {
                    label: t('Plan'),
                    value: 'plan',
                },
                {
                    label: t('Account Connect'),
                    value: 'amazon_account',
                },
                {
                    label: t('Bulk Export'),
                    value: 'csv_product',
                },
                {
                    label: t('Amazon Lookup'),
                    value: 'amazon_product_search',
                },
                {
                    label: t('Inventory Sync'),
                    value: 'inventory_sync',
                },
                {
                    label: t('Product Upload'),
                    value: 'product_upload',
                },
                {
                    label: t('Image Sync'),
                    value: 'image_sync',
                },

            ],
        },
        {
            label: t('Action Generated By'),
            subFilters: [
                {
                    label: t('Amazon'),
                    value: 'amazon',
                },
                {
                    label: t('Shopify'),
                    value: 'shopify',
                },
            ],
        },
        {
            label: t('Action created'),
            subFilters: [
                {
                    label: t('Automatically'),
                    value: 'automatically',
                },
                {
                    label: t('Manually'),
                    value: 'manually',
                },
            ],
        },
        {
            label: t('Status'),
            subFilters: [
                {
                    label: t('In progress'),
                    value: 'in_progress',
                },
                {
                    label: t('Completed'),
                    value: 'completed',
                },
                {
                    label: t('Failed'),
                    value: 'failed',
                },
            ],
        },
        {
            label: t('Date range'),
            subFilters: [
                {
                    label: t('Today'),
                    value: 'today',
                },
                {
                    label: t('Last 7 days'),
                    value: 'Last7days',
                },
                {
                    label: t('Last 30 days'),
                    value: 'Last30days',
                },
                {
                    label: t('Custom'),
                    value: 'custom_filter_date',
                },
            ],
        },
    ];
    const handleFIlter = (e: any) => {
        let temp = {};
        e.map((val: string) => {
            if (val === 'custom') {
                temp = {
                    ...temp,
                    custom_filter_date: {}
                }

            } else {
                temp = {
                    ...temp,
                    [val]: true
                }

            }

        })
        props.di.globalState.set('activityFilter', JSON.stringify(temp))

        setValue(temp)
    }

    const removeAllFilter = () => {
        props.di.globalState.set('activityFilter', JSON.stringify({}))
        setValue({})

    }

    const onRangeChange = (dates: any, dateStrings: string[]) => {

        if (dates) {
            let filter = {
                ...value,
                custom_filter_date: {
                    from: dates[0],
                    to: dates[1]
                }
            }
            setValue(filter)
            props.di.globalState.set('activityFilter', JSON.stringify(filter))
        }
    };

    return (
        <Drawer
            className="custom-notification-filter"
            title="More Filters"
            placement="right"
            closeIcon
            onClose={() => setActive(false)}
            open={active}
            footer={
                <InlineStack align="space-between">
                    <Button onClick={removeAllFilter} variant="secondary" size="medium">
                        Clear all filters
                    </Button>
                    <Button onClick={() => setActive(false)} variant="primary" size="medium">
                        Done
                    </Button>
                </InlineStack>
            }
            key={'right'}>
            {filterData.map((ele, index) => {
                return (
                    <React.Fragment key={index}>
                        <div
                            role="none"
                            className="FilterSheet__BodyAccordian-Header"
                            onClick={() =>
                                setOpen(open === index ? -1 : index)
                            }>
                            <InlineStack gap={'400'} align="space-between">
                                <Text
                                    as="p"
                                    variant="bodyLg"
                                    fontWeight="semibold">
                                    {ele.label}
                                </Text>
                                <span>
                                    <Icon source={ChevronDownMinor} />
                                </span>
                            </InlineStack>
                        </div>
                        <Collapsible
                            open={open === index}
                            id="basic-collapsible"
                            transition={{
                                duration: '500ms',
                                timingFunction: 'ease-in-out',
                            }}>
                            <div className="FilterSheet__BodyAccordian-Body">
                                <BlockStack gap={'200'}>

                                    <ChoiceList
                                        allowMultiple={ele.label !== 'Date range'}
                                        title=""
                                        titleHidden
                                        choices={ele.subFilters}
                                        selected={Object.keys(value)}
                                        onChange={(e: any) => {
                                            handleFIlter(e)
                                            // setSelected(e)
                                        }}
                                    />
                                    {Object.keys(value).includes('custom_filter_date') &&
                                        filterData.length - 1 === open && (

                                            <RangePicker
                                                format={dateFormatList}
                                                size="middle"
                                                onChange={onRangeChange}
                                                value={[value['custom_filter_date'].from, value['custom_filter_date'].from]}
                                            />
                                        )}
                                </BlockStack>
                            </div>
                        </Collapsible>
                    </React.Fragment>
                );
            })}
        </Drawer>
    );
};

export default FilterBy;